import { v4 as uuidv4 } from 'uuid';

export const getChallengeMessage = (address: string): string => {
  //
  const uuid = uuidv4();
  const challengeMessage = `Graviton: This signature is totally free of charge. You are proving the ownership of the wallet: ${address} \n\nNonce: ${uuid}`;
  return challengeMessage;
};
